module.exports = __webpack_public_path__ + "static/img/brees-2020-slide-8.72497b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2020-slide-8.jpg
// module id = ySmk
// module chunks = 1